import {ColorPickerLayout} from '@Components/color-picker-v2/color-picker-v2.types';
import {SwatchesLayout} from './swatches.types';

/** Palette layout for a colour picker section: a round grid in the popup, round swatches on mobile, squares in the side panel. */
export function getSwatchesLayout(colorPickerLayout: ColorPickerLayout, isMobileVersion: boolean): SwatchesLayout {
  if (colorPickerLayout === ColorPickerLayout.POPUP) {
    return SwatchesLayout.ROUND_GRID;
  }
  return isMobileVersion ? SwatchesLayout.ROUND_WRAP : SwatchesLayout.WRAP;
}
